import { mapState } from 'vuex';
import { Section, Center } from '@styled/global';
import styled from 'vue-styled-components';
import { fontSize, color } from 'styled-system';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   ", "\n\t\n   font-family: \"cnx-regular\", Arial, Helvetica, sans-serif;\n   font-style: normal;\n   font-weight: 200;\n   margin: 0px 10px 0px 10px;\n   padding: 0;\n   cursor: default;\n   -webkit-font-smoothing: antialiased;\n   text-align: left;\n\n   & sup {\n      font-size: 18px;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var H3 = styled("div", {
  fontSize: {
    default: function _default() {
      return [3, 3, 4, 5];
    },
    type: [Number, String, Object, Array]
  },
  color: {
    default: function _default() {
      return null;
    },
    type: [String]
  }
})(_templateObject(), fontSize, color);

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    },
    primary: {
      required: false,
      type: Boolean,
      default: false
    },
    align: {
      required: false,
      type: String,
      default: "left"
    },
    color: {
      required: false,
      type: String,
      default: null
    }
  },
  computed: _extends({}, mapState("theme", ["theme"])),
  render: function render() {
    var h = arguments[0];
    var color = this.color ? this.color : this.theme.primaryColor;
    return h(Section, {
      "attrs": {
        "mt": "20px",
        "padding": "0 3vw",
        "minHeight": "60px"
      }
    }, [h(Center, [h(H3, {
      "attrs": {
        "color": color
      },
      "domProps": {
        "innerHTML": this.copy.body
      }
    })])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
